const dateTime = {
    transformTime(date) {
        var time = new Date();
        let dateTime = new Date(time.setTime(date * 1000));
        // console.log("time",time)
        var y = dateTime.getFullYear();
        var M = dateTime.getMonth() + 1;
        var d = dateTime.getDate();
        var h = dateTime.getHours();
        var m = dateTime.getMinutes();
        var s = dateTime.getSeconds();
        return y + '-' + addZero(M) + '-' + addZero(d);
        // 
    },
    // 时间戳转换 年月日 时分秒
    timestampYMDHms(date) {
        var time = new Date();
        let dateTime = new Date(time.setTime(date * 1000));
        // console.log("time",time)
        var y = dateTime.getFullYear();
        var M = dateTime.getMonth() + 1;
        var d = dateTime.getDate();
        var h = dateTime.getHours();
        var m = dateTime.getMinutes();
        var s = dateTime.getSeconds();
        return y + '-' + addZero(M) + '-' + addZero(d) + '  ' + addZero(h) + ":" + addZero(m) + ":" + addZero(s);
    }

}

const addZero = (m) => {
    return m < 10 ? '0' + m : m;
}

export default dateTime


// WEBPACK FOOTER //
// ./src/utils/dateTime.js